<template>
  <v-container fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9" md="6" class="d-flex justify-center">
        <v-img :src="require('@/assets/modalLogb.png')" class="responsive-logo" max-width="350"></v-img>

      </v-col>
      <v-divider vertical inset></v-divider>
      <v-col cols="12" sm="9" md="6" v-if="dialogLogin">
        <v-flex>
          <v-card class="elevation-0">
            <v-card-text class="headline text-center">Login Admin</v-card-text>
            <v-card-text>
              <v-form>
                <v-text-field outlined prepend-inner-icon="mdi-account" name="login" label="Login" v-model="email"
                  type="email"></v-text-field>
                <v-text-field outlined id="password" prepend-inner-icon="mdi-lock" name="password" v-model="password"
                  label="Password" type="password"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="px-4">
              <v-btn color="primary" type="submit" @click="login" block>Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-col>

      <v-col cols="12" sm="9" md="6" v-if="dialog2">
        <v-card class="elevation-0">
          <v-card-text class="headline text-center">Two-Factor Authentication</v-card-text>
          <v-card-text>
            <p class="text-center">Authentication code</p>
            <v-form ref="form" @submit.prevent="initCheck2Fa">
              <v-text-field outlined prepend-inner-icon="mdi-lock" placeholder="XXXXXX" v-model="tokenPassword" :rules="[
          v => !!v || 'Code is required',
          v => (v && v.length === 6) || 'Code must be 6 characters'
        ]" maxlength="6" type="password" clearable></v-text-field>
            </v-form>
            <div v-if="textLogin" class="d-flex text-center justify-center">
              <p class="mb-0">&nbsp; {{ timeRemaining }} </p>
            </div>
            <div v-else class="d-flex text-center justify-center">
              <p class="mb-0">&nbsp; {{ timeRemaining2 }} </p>
            </div>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-btn color="primary" block type="submit" :disabled="disbleBtn" @click="initCheck2Fa">Verify</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-center">
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            {{ text }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
      Login failed please try again
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { authenticator } from "otplib";
import axios from "@/config/axios";
export default {
  data: () => ({
    email: "",
    password: "",
    dialog: false,
    dialog2: false,
    dialogLogin: true,
    snackbar: false,
    timeout: 2000,
    user: "Siampiwat",
    service: "admin@siampremium.com",
    token: '',
    tokenPassword: '',
    timeRemaining: '',
    text: 'loading...',
    timeInterval: null,
    disbleBtn: false,
    diffSeconds: 0,
    textLogin: true,
    timeRemaining2: ''
  }),
  methods: {
    converDateToStringThialand(date) {
      // convert date to string thailand
      const dateNow = new Date(date);
      const dateNowString = dateNow.toLocaleString('th-TH', {
        timeZone: 'Asia/Bangkok',
        hour: 'numeric',
        minute: 'numeric',
      });
      return dateNowString
    },
   
    async initCheck2Fa() {
      if (this.disbleBtn || !this.$refs.form.validate()) return;
      this.disbleBtn = true;
      try {
        const uid = this.$store.state.uid;
        const { data } = await axios.post('/mfa/verify', { code: this.tokenPassword }, {
          headers: { Authorization: 'Bearer ' + uid },
        });
        if (data.success) {
          this.dialog = true;
          this.text = 'Loading...';
          setTimeout(() => {
            this.$router.push({ name: 'admin' });
          }, 1500);
        } else {
          this.snackbar = true;
          this.tokenPassword = '';
          this.disbleBtn = false;
        }
      } catch (err) {
        this.snackbar = true;
        this.tokenPassword = '';
        this.disbleBtn = false;
      }
    },

    async login() {
      this.dialog = true;
      this.text = 'Loading...';
      try {
        const uid = await this.$store.dispatch('login', { email: this.email, password: this.password });
        if (!uid) throw new Error('Login failed');
        const { data } = await axios.get('/mfa/status', {
          headers: { Authorization: 'Bearer ' + uid },
        });
        this.dialog = false;
        if (data.mfaEnabled) {
          this.dialog2 = true;
          this.dialogLogin = false;
        } else {
          this.$router.push({ name: 'mfaSetup' });
        }
      } catch (err) {
        this.dialog = false;
        this.snackbar = true;
      }
    },

    clearIntervalExpire() {
      this.disbleBtn = true
      clearInterval(this.timeInterval);
    },

    createToken2FA() {
      // generate password token
      // const token = authenticator.generate(process.env.VUE_APP_SECERT);
      // console.log('token :>> ', token);


      // generate QR code
      // const otpauth = authenticator.keyuri(this.user, this.service, process.env.VUE_APP_SECERT);

      // qrcode.toDataURL(otpauth, (err, imageUrl) => {
      //   if (err) {
      //     console.log('Error with QR');
      //     return;
      //   }
      //   console.log(imageUrl);
      // });



    },

    checkDiffSeconds() {
      const dateNow = new Date();
      const dateEnd = new Date(this.$store.state.timeExpire);
      const diff = dateEnd - dateNow;
      const resultDiff = diff / 1000;
      if (+resultDiff < 0) {
        this.textLogin = true
        this.disbleBtn = false
        this.countdownSeconds()
      } else {
        this.clearIntervalExpire()
        this.textLogin = false
        const textTimeEnd = this.converDateToStringThialand(this.$store.state.timeExpire);
        this.disbleBtn = true
        this.timeRemaining2 = `Login again after time : ${textTimeEnd} `

      }

    },
    countdownSeconds() {
      this.timeInterval = setInterval(() => {
        if (authenticator.timeRemaining() - 2 > 0) {
          this.timeRemaining = `time remain : ${authenticator.timeRemaining() - 2} seconds`;
          return this.timeRemaining
        } else {
          this.timeRemaining = "expired please try again"
          return this.timeRemaining
        }
      }, 1000);
    },

    setIntervalTime() {
      setInterval(() => {
        this.checkDiffSeconds()
      }, 1000);
    }

  },

  created() {
    this.setIntervalTime()
  },



};
</script>

<style>
.responsive-logo {
  width: 70%;
  height: auto;
}
</style>